import { apiFetch } from "@/lib/api";

export interface AnalysisTransfer {
  id: number;
  deviceLabelSerial: string;
  deviceId: number | null;
  serialFciId: number | null;
  destinationLocationId: number;
  destinationName: string | null;
  sentAt: string;
  sentBy: string;
  returnedAt: string | null;
  returnedBy: string | null;
  notes: string | null;
  rmaId: number | null;
  qualityCaseId: number | null;
  investigationId: number | null;
  qualityIncidentId: number | null;
}

export interface AnalysisTransferParent {
  rmaId?: number;
  qualityCaseId?: number;
  investigationId?: number;
  qualityIncidentId?: number;
}

export const ANALYSIS_TRANSFERS_KEY = ["quality", "analysis-transfers"] as const;

export function analysisTransfersQueryKey(parent: AnalysisTransferParent & { activeOnly?: boolean }): readonly unknown[] {
  return [...ANALYSIS_TRANSFERS_KEY, parent];
}

export async function fetchAnalysisLocations(): Promise<{ rows: Array<{ id: number; name: string }> }> {
  return apiFetch("/api/quality/analysis-transfers/locations");
}

export async function fetchAnalysisTransfers(
  parent: AnalysisTransferParent & { activeOnly?: boolean },
): Promise<{ rows: AnalysisTransfer[] }> {
  return apiFetch("/api/quality/analysis-transfers", {
    query: {
      rmaId: parent.rmaId != null ? String(parent.rmaId) : undefined,
      qualityCaseId: parent.qualityCaseId != null ? String(parent.qualityCaseId) : undefined,
      investigationId: parent.investigationId != null ? String(parent.investigationId) : undefined,
      qualityIncidentId: parent.qualityIncidentId != null ? String(parent.qualityIncidentId) : undefined,
      activeOnly: parent.activeOnly ? "true" : undefined,
    },
  });
}

export async function fetchActiveAnalysisTransfers(): Promise<{ rows: AnalysisTransfer[] }> {
  return apiFetch("/api/quality/analysis-transfers/active");
}

export async function fetchAnalysisTransfer(id: number): Promise<{ row: AnalysisTransfer }> {
  return apiFetch(`/api/quality/analysis-transfers/${id}`);
}

export async function createAnalysisTransfer(
  input: AnalysisTransferParent & {
    deviceLabelSerial: string;
    destinationLocationId: number;
    notes?: string | null;
    printLabel?: boolean;
    printer?: string;
  },
): Promise<{ row: AnalysisTransfer; labelPrinted?: boolean; labelError?: string }> {
  return apiFetch("/api/quality/analysis-transfers", {
    method: "POST",
    body: input,
  });
}

export async function printAnalysisTransferLabel(
  id: number,
  printer: string,
): Promise<{ printed: boolean }> {
  return apiFetch(`/api/quality/analysis-transfers/${id}/print-label`, {
    method: "POST",
    body: { printer },
  });
}

export async function returnAnalysisTransfer(
  id: number,
  notes?: string | null,
): Promise<{ row: AnalysisTransfer }> {
  return apiFetch(`/api/quality/analysis-transfers/${id}/return`, {
    method: "POST",
    body: { notes: notes ?? null },
  });
}
